<template>
  <div class="container no-margin grid-container grid-container--6-6">
    <select-autocomplete-only-letters
      class="col1"
      placeholder="Ej: DNI"
      label="Tipo de documento"
      maxlength="3"
      v-model="value.tipo"
      name="tipoDocumento"
      :required="required"
      :items="tiposDocumento"
      :validationError="validationError"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @focus="trackClick('tipoDocumento')"
    />

    <number-input
      class="col2"
      placeholder="Ej: 43464800"
      label="Número de documento"
      name="numeroDocumento"
      maxlength="8"
      v-model="value.numero"
      :required="required"
      :scroll-on-focus="scrollOnFocus"
      @focus="trackClick('numeroDocumento')"
    />
  </div>
</template>

<script>
import { tiposDocumento } from "@/config/constants";
import NumberInput from "@/components/core/NumberInput";
import SelectAutocompleteOnlyLetters from "@/components/core/custom/SelectAutocompleteOnlyLetters";
import { DO_ADOBE_APPSTARTED } from "@/config/constants/action-types";

export default {
  name: "DocumentNumber",
  components: { NumberInput, SelectAutocompleteOnlyLetters },
  props: {
    label: String,
    value: Object,
    scrollOnFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValid(this.value.tipo);
      }
    },
    checkValid() {
      this.checked = true;
      return this.isValid(this.value.tipo);
    },
    isValid(val) {
      // El código de área debe ser numérico
      // El método sólo valida el código de área ya que el número se valida solo
      const pattern = new RegExp("^[A-Za-z]+$", "i");
      if (pattern.test(val)) {
        // El valor es numérico
        this.validationError = null;
        return true;
      }
      this.validationError = "El tipo de documento no es válido";
      return false;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(DO_ADOBE_APPSTARTED, el);
    }
  },
  computed: {
    tiposDocumento() {
      return tiposDocumento;
    }
  }
};
</script>

<style scoped></style>
